import MapOutlined from "@mui/icons-material/MapOutlined";
import { Box } from "@mui/material";
import { useState } from "react";
import { PageContainer } from "@/components/Responsive";
import { ReassistButton } from "@/features/reassistRequests/components/ReassistButton";
import { ReassistPageHeader } from "@/features/reassistRequests/components/ReassistPageHeader";
import {
  REASSIST_CONTENT_MAX_WIDTH,
  REASSIST_LABELS,
  REASSIST_MAP_PATH,
} from "@/features/reassistRequests/config";
import { MOBILE_BREAKPOINT } from "@/styles/responsive";
import { useSaleDocuments } from "../api/useReassistSale";
import { SaleDetailDialog } from "../components/SaleDetailDialog";
import { SaleSearchList } from "../components/SaleSearchList";
import { formatPriceWithYen } from "../utils/format";

/** SP でも文字の大きさを方針の6段（px 固定）に保つため、PageContainer の文字縮小を掛けない。 */
const NO_COMPACT = {};

/**
 * 見出し下の説明文。価格は一覧の先頭の物件の値を使う（DB で変えられるため直書きしない）。
 * 価格が分からないとき・未設定のときは、価格に触れない文にする。
 */
const descriptionText = (price: number | null | undefined): string => {
  if (price === null || price === undefined) {
    return "アーカイブ提供資料（個人情報等は黒塗り済み）を、PDFごとに購入できます。";
  }
  return `アーカイブ提供資料（個人情報等は黒塗り済み）を、1PDF ${formatPriceWithYen(
    price
  )}で購入できます。`;
};

/** 役所資料（黒塗り）を探して購入するページ。一覧検索ができ、地図で探すときは地図画面へ進む。 */
export const ReassistSalePage: React.FC = () => {
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const { data: firstPage } = useSaleDocuments("", 0);

  return (
    <PageContainer compactSx={NO_COMPACT}>
      <Box
        sx={{
          width: "100%",
          maxWidth: REASSIST_CONTENT_MAX_WIDTH,
          boxSizing: "border-box",
        }}
      >
        <Box sx={{ mb: { xs: 3, [MOBILE_BREAKPOINT]: 4 } }}>
          <ReassistPageHeader
            title={REASSIST_LABELS.archive}
            description={descriptionText(firstPage?.results[0]?.price)}
            actions={
              <ReassistButton
                label={REASSIST_LABELS.map}
                variant="outlined"
                to={REASSIST_MAP_PATH}
                startIcon={<MapOutlined />}
              />
            }
          />
        </Box>
        <SaleSearchList onSelect={setSelectedId} />
      </Box>
      <SaleDetailDialog
        documentId={selectedId}
        onClose={() => {
          setSelectedId(null);
        }}
      />
    </PageContainer>
  );
};
